import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="layout-top, margin, padding" maskId="round-filled-radius-1-stroke-1.5-IconLayoutTop"><path d="M3 8.75C3 7.7835 3.7835 7 4.75 7H19.25C20.2165 7 21 7.7835 21 8.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V8.75Z" fill="currentColor"/><path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75C21 4.16421 20.6642 4.5 20.25 4.5H3.75C3.33579 4.5 3 4.16421 3 3.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutTop;
